import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/home',
      component: () => import(/* webpackChunkName: "ajax" */ './layouts/default'),
      children: [
        {
          path: 'home',
          name: 'home',
          component: Home
        },
        {
          path: 'ajax',
          name: 'Ajax',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "ajax" */ './views/Ajax.vue')
        },
        {
          path: 'raf',
          name: 'RequestAnimationFrame',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "raf" */ './views/RAF.vue')
        },
        {
          path: 'run-interval',
          name: 'Run Interval',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "run-interval" */ './views/RunInterval.vue')
        },
        {
          path: 'recursive',
          name: 'Run recursive',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "recursive" */ './views/Recursive.vue')
        },
        {
          path: 'drag',
          name: 'drag',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "drag" */ './views/Drag.vue')
        },
        {
          path: 'graph',
          name: 'graph',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "graph" */ './views/Graph.vue')
        },
        {
          path: 'clock',
          name: 'clock',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "clock" */ './views/Clock.vue')
        },
        {
          path: 'sync-v-model-example',
          name: 'sync-v-model-example',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "test" */ './views/SyncVModelExample.vue')
        },
        {
          path: 'about',
          name: 'about',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
        },
        {
          path: 'uml',
          name: 'uml',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "uml" */ './views/Uml.vue')
        },
        {
          path: 'uml2',
          name: 'uml2',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "uml2" */ './views/Uml2.vue')
        },
        {
          path: 'uml3',
          name: 'uml3',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "uml2" */ './views/Uml3.vue')
        },
        {
          path: 'infinite-table',
          name: 'infinite-table',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "uml" */ './views/InfiniteTable.vue')
        }
      ]
    }
  ]
})
